import React from "react";
import LoadingSpinner from "./LoadingSpinner";

const PageSpinner = () => <LoadingSpinner loading size="4rem" />;

export default PageSpinner;
